const PenOutlineIcon = () => {
    return (
        <svg
            id="Group_8342"
            data-name="Group 8342"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 24.658 18"
        >
            <g id="Group_8341" data-name="Group 8341">
                <path
                    id="Path_3568"
                    data-name="Path 3568"
                    d="M7.031,17.316l3.388-1.129L20.741,5.867M7.031,17.316l1.129-3.388L18.482,3.608M7.031,17.316H.375M18.482,3.608,21.714.375l2.259,2.259L20.741,5.867"
                    transform="translate(0.154 0.154)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default PenOutlineIcon;
